export default {"src":"/_next/static/media/networking.dff45acc.svg","height":764,"width":938,"blurWidth":0,"blurHeight":0};